import { RBHImage, RBHText } from '..';
import React from 'react';
import { Images } from '../../theme';
import commonStyle from '../../theme/common-style';
import RBHBox from '../rbh-box';
import styleImage from '../rbh-image/styles';
import styleText from '../rbh-text/styles';
import styles from './styles';

export const RBHEmpty: React.FC<Props> = (p) => {
  return (
    <RBHBox style={styles.defaultContent}>
      <RBHImage id={'empty-data-image'} style={{ ...styleImage.icon200, ...commonStyle.marginBottomLarge }} src={Images.emptyState} />
      <RBHText id={'emptyTitle'} data-testid={'emptyTitle'} style={styleText.exceptionHeader} text={p.textTitle} />
      <RBHText id={'emptyContent'} data-testid={'emptyContent'} style={{ ...styleText.exceptionContent, paddingBottom: 40 }} text={p.textContent} />
      {p.children}
    </RBHBox>
  );
};

type Props = {
  textTitle: string
  textContent: string
  onOk?: any
};

export default RBHEmpty;
